<div class="bg-white" *ngIf="!isLoadingTripDetails" ridangoAriaVisibilityObserver>
    <ng-template #stickyHeader>
        <div class="flex-align-center flex justify-between bg-white p-3 pb-1">
            <rwidget-route-name
                [routeNumberLabel]="data?.tripRouteNr"
                [routeNumberColor]="data?.tripRouteColor"
                [routeNumberTextColor]="data?.tripRouteTextColor"
                [routeNumberShape]="data?.tripRouteShape"
                [operatorCode]="data?.tripRouteOperatorCode"
                [operatorName]="data?.tripRouteOperatorName"
                [name]="data?.tripRouteName"
                [isLive]="data?.isLive"
                [delay]="data?.delay"></rwidget-route-name>
            <ion-button
                [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                (click)="handleClose()"
                (keydown.enter)="handleClose()"
                (keydown.space)="handleClose()"
                slot="end"
                fill="clear">
                <ion-icon
                    class="var-app-light:text-[#323232] my-0 h-8 w-8 dark:filter-yellow"
                    title="{{ 'LOCAL_BTN_BACK' | translate }}"
                    attr.aria-label="{{ 'LOCAL_BTN_BACK' | translate }}"
                    src="{{ assetsPath$ | async }}/img/explore/cross.svg"></ion-icon>
            </ion-button>
        </div>
    </ng-template>
    <div
        class="mx-4 mb-4 mt-3 flex h-14 items-center gap-2 rounded-lg bg-danger px-3"
        *ngIf="env.EXPLORE.SHOW_CANCELLED_STATUS && isCancelled">
        <ion-icon
            class="h-8 w-8"
            aria-hidden="true"
            src="{{ assetsPath$ | async }}/img/explore/icon-alert.svg"></ion-icon>
        <span class="text-[1rem] leading-5 text-white">{{ 'TRIP_IS_CANCELLED_TEXT' | translate }}</span>
    </div>
    <div class="flex flex-col gap-4 px-3 py-1" *ngIf="data?.tripRouteMessages?.length">
        <ng-container *ngFor="let message of data?.tripRouteMessages; let last = last">
            <rwidget-caption
                *ngIf="
                    message.messageType === DisruptionMessageType.ALERT_BUS ||
                    message.messageType === DisruptionMessageType.ALERT_GENERIC
                "
                [ngClass]="{ 'mb-4': last }"
                [disruptionMessage]="message"></rwidget-caption>
        </ng-container>
    </div>
    <div
        class="var-app-light:bg-primary var-app-light:text-white vl-app-light:bg-primary drt-message flex-align-center margin-right-4 m-4 mt-0 flex gap-5 rounded-lg px-2 py-6 dark:border-2 dark:border-solid dark:border-contrast-yellow"
        *ngIf="data?.tripRouteMode === TransportMode.Flexible">
        <ion-icon
            class="var-app-light:text-white h-8 w-8 dark:text-contrast-yellow"
            [src]="(assetsPath$ | async) + '/img/journey-planner/drt-bus.svg'"
            aria-hidden="true"
            alt="DRT bus icon"></ion-icon>
        <p class="flex-1 text-base text-white">
            <span class="drt-message" innerHtml="{{ 'EXPLORE_DRT_BUS_MESSAGE' | translate }}"></span>
        </p>
    </div>

    <div class="border-ironside_grey-100 border-t border-solid dark:border-contrast-yellow"></div>

    <div
        class="word-break-break-word mt-3 grid auto-rows-auto grid-cols-[auto_5rem_1fr] px-5 pb-4 pt-0 native-app:pb-28">
        <ng-container *ngFor="let time of data?.times; let i = index">
            <div
                class="flex-align-center flex pb-2 pt-2"
                [ngClass]="{
                    'text-black dark:text-contrast-yellow': time.stopId === data?.userDepartStopId,
                    'text-old_silver dark:text-contrast-yellow': time.stopId !== data?.userDepartStopId,
                    'font-bold': time.stopId === data?.userDepartStopId
                }">
                <div class="flex flex-col dark:text-contrast-yellow">
                    <div
                        [ngClass]="{
                            'text-danger line-through': env.EXPLORE?.SHOW_CANCELLED_STATUS && time.canceled,
                            'italic': env.TIMEPOINTS_ENABLED && !time.timepoint
                        }">
                        {{ time.departureTime | dateTime: departureTimeFormat }}
                    </div>
                    <div
                        class="flex items-end justify-end text-xs line-through"
                        *ngIf="time?.scheduledTimeExceedingAllowedThreshold">
                        {{ time.scheduledTime | dateTime: departureTimeFormat }}
                    </div>
                </div>
            </div>
            <div class="flex-justify-center relative flex">
                <div
                    class="flex-justify-center flex-align-center relative flex w-1.5"
                    [ngStyle]="(lineStyles$ | async)?.[i]">
                    <div
                        class="absolute z-10 h-2.5 w-2.5 rounded-full border-[3px] border-solid bg-white dark:border-contrast-yellow dark:bg-contrast-black"
                        *ngIf="time.stopId !== data?.userDepartStopId"
                        [ngStyle]="getStopCircleBorderColor$ | async"></div>
                    <img
                        class="relative z-10 max-w-none"
                        *ngIf="time.stopId === data?.userDepartStopId"
                        [src]="
                            (assetsPath$ | async) +
                            (env.EXPLORE?.USE_CONTRAST_ICON && (isContrast$ | async)
                                ? '/img/explore/person-circle-contrast.svg'
                                : '/img/explore/person-circle.svg')
                        "
                        alt="User location" />
                </div>

                <div
                    class="absolute left-1/2 top-0 z-20 flex h-[35px] w-[35px] -translate-x-1/2 transform items-center justify-center rounded-full"
                    *ngIf="(busVisibilityByLine$ | async)?.[i]"
                    [ngStyle]="{ top: ((busPositionByLine$ | async)?.[i] || 50) + '%' }">
                    <div
                        class="absolute inset-0 rounded-full border-2 border-solid"
                        [ngStyle]="busOuterBorderStyle$ | async"></div>
                    <div
                        class="relative flex h-7 w-7 items-center justify-center rounded-full border border-solid border-white"
                        [ngStyle]="busInnerStyle$ | async">
                        <img
                            class="h-3 w-3 brightness-0"
                            [ngClass]="{ invert: (applicationFacade.highContrast$ | async) !== true }"
                            [src]="(assetsPath$ | async) + '/img/journey-planner/bus.svg'"
                            alt="Bus location" />
                    </div>
                </div>
            </div>

            <button
                class="flex-align-center flex w-full flex-col items-start border-0 bg-transparent pb-2 pt-2 text-left"
                [ngClass]="{
                    'font-bold': time.stopId === data?.userDepartStopId,
                    'text-[#D04D43] line-through': env.EXPLORE?.SHOW_CANCELLED_STATUS && time.canceled
                }"
                (click)="openStopDetails(time.stopId)"
                (keydown.enter)="openStopDetails(time.stopId)"
                (keydown.space)="openStopDetails(time.stopId)"
                type="button"
                tabindex="0">
                <div class="inline">
                    <span>{{ time.stop?.name }}</span>
                    <span *ngIf="time.stop?.desc && env.EXPLORE?.SHOW_MUNICIPALITY_IN_STOP_NAME">
                        ({{ time.stop.desc }})</span
                    >
                </div>
                <span
                    class="text-xm text-black dark:text-contrast-yellow"
                    *ngIf="time?.pickupType === PickupType.NO_PICKUP && this.env.SHOW_PICK_UP_DROP_OFF_INFO">
                    {{ 'DROP_OFF_ONLY' | translate }}
                </span>
                <span
                    class="text-xm text-black dark:text-contrast-yellow"
                    *ngIf="time?.dropOffType === DropOffType.NO_DROP_OFF && this.env.SHOW_PICK_UP_DROP_OFF_INFO">
                    {{ 'ALIGHTING_ONLY' | translate }}
                </span>
                <rwidget-disruption-message
                    *ngFor="let message of time.stop?.disruptionMessages"
                    [disruptionMessage]="message"
                    [commonExtraClasses]="'mb-1 p-1 text-xs font-semibold'"
                    [commonExtraSpanClasses]="'text-xs font-semibold'"></rwidget-disruption-message>
            </button>
        </ng-container>
    </div>
</div>

<div class="bg-white dark:bg-contrast-black" *ngIf="isLoadingTripDetails">
    <div class="flex px-2 pt-2">
        <ridango-ui-skeleton-loader class="w-full" height="4rem" count="10"> </ridango-ui-skeleton-loader>
    </div>
</div>
